<template>
  <div>
    <BaseHeader :backPopup="isCancel" />
    <div class="container_wrap basic">
      <form name="payment">
        <BaseTitle
          :title="isFreeBooking ? '예약하시겠습니까?' : pageName"
          :isStep="true"
        />

        <div class="container payment">
          <BaseContainer class="booker_info" title="예약자 정보">
            <template #containerContent>
              <BaseField v-if="userInfo?.clientName" label="회사명">
                <template #fieldContent>{{ userInfo.clientName }}</template>
              </BaseField>
              <BaseField v-if="userInfo?.memberName" label="이름">
                <template #fieldContent>{{ userInfo.memberName }}</template>
              </BaseField>
              <BaseField v-if="userInfo?.employeeNo" label="사번">
                <template #fieldContent>{{ userInfo.employeeNo }}</template>
              </BaseField>
              <BaseField v-if="userInfo?.deptName" label="부서">
                <template #fieldContent>{{ userInfo.deptName }}</template>
              </BaseField>
              <BaseField v-if="userInfo?.clientCustomId" label="CJ월드 ID">
                <template #fieldContent>{{ userInfo.clientCustomId }}</template>
              </BaseField>
              <BaseField v-if="userInfo?.email" label="이메일">
                <template #fieldContent>{{ userInfo.email }}</template>
              </BaseField>
              <BaseField v-if="userInfo?.phone" label="휴대폰번호">
                <template #fieldContent>{{ userInfo.phone }}</template>
              </BaseField>
              <BaseField v-if="userInfo?.carNo" label="주차">
                <template #fieldContent>주차 필요</template>
              </BaseField>
              <BaseField v-if="userInfo?.carNo" label="차량번호">
                <template #fieldContent>{{ userInfo.carNo }}</template>
              </BaseField>
              <BaseField v-if="userInfo?.carNo === ''" label="주차">
                <template #fieldContent>주차 필요없음</template>
              </BaseField>
            </template>
          </BaseContainer>

          <BaseContainer
            class="reserv_info"
            :title="reservInfoTitle"
            :isFolding="true"
          >
            <template #containerContent>
              <div
                class="info_box"
                v-for="(line, idx) in selectedLines"
                :key="idx"
              >
                <BaseField label="예약날짜">
                  <template #fieldContent>
                    {{ line.dateText }}
                    <span class="desti">{{ line.bookType }}</span>
                  </template>
                </BaseField>

                <!-- <BaseField v-if="isEtcLine" label="도착지">
									<template #fieldContent>
										{{ line.line.lineTurnName }}
									</template>
								</BaseField> -->

                <BaseField label="노선">
                  <template #fieldContent>
                    <a
                      @click="openMapInfo(line, 'onStation')"
                      class="map_I go_event"
                    >
                      {{ line.onStation.displayText }}
                    </a>
                    <a
                      @click="openMapInfo(line, 'offStation')"
                      class="map_I go_event"
                    >
                      {{ line.offStation.displayText }}
                    </a>
                  </template>
                </BaseField>

                <BaseField label="탑승인원">
                  <template #fieldContent>
                    <span>
                      {{ `${line.targetList.length}명` }}
                    </span>
                    <span v-if="line.targetText">{{
                      `(${line.targetText})`
                    }}</span>
                  </template>
                </BaseField>

                <BaseField v-if="line.fareAmount" label="운임">
                  <template #fieldContent>
                    {{ `${line.fareAmount.toLocaleString()}원` }}
                  </template>
                </BaseField>

                <BaseField label="좌석">
                  <template #fieldContent>
                    <div
                      v-if="line.seats[0]?.seatNo"
                      v-html="line.seatDisplayText"
                    ></div>
                    <div v-else>자유석</div>
                  </template>
                </BaseField>
              </div>
            </template>
          </BaseContainer>

          <BaseContainer
            v-if="pgList?.length > 1"
            class="pay_info"
            title="결제수단"
          >
            <template #containerContent>
              <template v-for="(pg, idx) in pgList" :key="idx">
                <input
                  type="radio"
                  :id="pg.code"
                  name="pay"
                  :value="pg.code"
                  v-model="payType"
                />
                <label
                  :for="pg.code"
                  :class="{ active: payType === pg.code }"
                  >{{ pg.displayText }}</label
                >
              </template>
            </template>
          </BaseContainer>
        </div>

        <BaseInfo :infoList="infoList" />

        <BaseButton
          v-if="isFreeBooking"
          class="btnB active"
          :name="`${payTitle}하기`"
          @click="onceClick(openPopupForPay)()"
        />
        <BaseButton
          v-else
          class="btnB active"
          :name="`총 ${totalFareAmount.toLocaleString()}원 결제하기`"
          @click="onceClick(openPopupForPay)()"
        />
      </form>
    </div>

    <iframe
      id="kcpFrame"
      name="kcpFrame"
      method="POST"
      style="display: none; width: 0; height: 0; border: 0; border: none"
    ></iframe>

    <form id="kcpForm" name="kcpForm" method="POST">
      <input type="hidden" name="jsonBody" />
      <input type="hidden" name="accessToken" :value="accessToken" />
    </form>
  </div>
</template>

<script>
import BaseButton from "@/components/Base/BaseButton";
import BaseContainer from "@/components/Base/BaseContainer";
import BaseField from "@/components/Base/BaseField";
import BaseHeader from "@/components/Base/BaseHeader.vue";
import BaseInfo from "@/components/Base/BaseInfo.vue";
import BaseTitle from "@/components/Base/BaseTitle.vue";
import useIsMobile from "@/composables/useIsMobile.js";
import dayjs from "dayjs";
import {
  computed,
  getCurrentInstance,
  onBeforeMount,
  onBeforeUnmount,
  ref,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  name: "Pay",
  props: {
    page: {
      type: String,
    },
    pageName: {
      type: String,
    },
  },
  components: {
    BaseButton,
    BaseContainer,
    BaseField,
    BaseHeader,
    BaseInfo,
    BaseTitle,
  },
  setup(_props, { emit }) {
    const infoList = [
      "탑승 시 승무원에게 모바일티켓을 제시해주세요.",
      "반드시 본인이 예약한 차량의 예약한 좌석에 탑승하여 주시기 바랍니다.",
    ];
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const { proxy } = getCurrentInstance();

    const serviceInfo = store.state.common.serviceInfo;
    const isEtcLine = computed(() => route.fullPath.includes("etc"));
    const bookUid = computed(() => store.state.book.bookUid); // 임시 예약했던 식별자
    const isPaying = ref(false);
    const isCancel = ref(false); // 결제 실패 화면에서 결제하기 화면으로 돌아왔는지 여부
    const pgList = computed(() => store.state.book.pgList);
    const payType = ref(pgList.value?.[0]?.code ?? "");
    const isFreeBooking = computed(() =>
      pgList.value?.some((pg) => pg.code === "PGC-FREE")
    );
    const payTitle = computed(() => {
      if (isEtcLine.value) {
        return "신청";
      } else if (isFreeBooking.value) {
        return "예약";
      } else {
        return "결제";
      }
    });
    const reservInfoTitle = computed(() =>
      isEtcLine.value ? "신청내역" : "예약내역"
    );

    // 예약 만료로 인해 결제 실패된 경우 에러 팝업 표출 후 메인화면을 이동 처리
    const resultCode = route.params.resultCode?.toString() ?? "";
    const callBackFunc = () => router.push({ name: "Main" });
    if (resultCode === "408100001") {
      proxy.$root.$openErrorPopup({
        errorCode: resultCode,
        errorTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        errorMessage:
          "예약 시간 만료로 인해 예약이 되지 않았습니다. 다시 시도해주세요.",
        callBackFunc,
      });
    } else if (resultCode === "500000000") {
      proxy.$root.$openErrorPopup({
        errorCode: resultCode,
        errorTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        errorMessage:
          "결제에 실패했습니다. 컨텍센터(1599-9360)로 문의해주세요.",
      });
    }

    // 결제 취소, 결제 실패로 돌아온 경우
    const payInfo = JSON.parse(window.sessionStorage.getItem("payInfo"));
    const setPayInfo = (payInfo) => {
      const {
        forwardLines,
        backwardLines,
        userInfo,
        bookUid,
        hasAssignedSeatLine,
      } = payInfo;
      store.dispatch("member/SET_USER_INFO", userInfo);
      store.dispatch("book/SET_FORWARD_LINES", forwardLines);
      store.dispatch("book/SET_BACKWARD_LINES", backwardLines);
      store.dispatch("book/SET_BOOK_UID", { uid: bookUid });
      store.dispatch("line/SET_HAS_ASSIGNED_SEAT_LINE", hasAssignedSeatLine);
      window.sessionStorage.removeItem("payInfo");
    };

    if (payInfo) {
      isPaying.value = false;
      isCancel.value = true;
      setPayInfo(payInfo);
    }

    // lines 없는 경우 메인 화면으로 이동
    const lines = computed(() => store.getters["book/lines"]);
    if (lines.value.length === 0) {
      alert("예약 데이터가 존재하지 않아 결제 화면으로 이동할 수 없습니다.");
      router.push({ name: "Main" });
    }

    const userInfo = computed(() => store.state.member.userInfo);
    const selectedLines = computed(() => store.getters["book/selectedLines"]);
    const totalFareAmount = computed(() =>
      selectedLines.value.reduce(
        (totalFareAmount, line) => totalFareAmount + line.fareAmount,
        0
      )
    );

    const openMapInfo = (line, type) => {
      let stations = [];
      if (type === "onStation") {
        stations.push(line.onStation);
      } else {
        stations.push(line.offStation);
      }
      emit("openMapInfo", stations);
    };

    // 새로고침
    const setRefresh = (event) => {
      if (!isPaying.value) {
        event.preventDefault();
        event.returnValue = "";
      }
    };

    onBeforeMount(() => {
      if (!pgList.value?.length) {
        getPG();
      }
      window.addEventListener("beforeunload", setRefresh);
    });

    onBeforeUnmount(() => {
      window.sessionStorage.removeItem("payInfo");
      window.removeEventListener("beforeunload", setRefresh);
    });

    // 무료 예약 확정
    const freeBook = async () => {
      /**
       * joinFirst=false 인 경우 BookInfo 단계에서 AccessToken이 없어 임시 예약(book-temp)을
       * 호출하지 못한다. 따라서 인증이 끝난 결제 화면에서 book-free API로 무료 예약을 즉시 확정한다.
       */
      if (!joinFirst.value) {
        await bookFree();
        return;
      }

      const result = await store.dispatch("book/APPROVE_BOOK_FREE", {
        bookUid: bookUid.value,
      });

      if (result.resultCode === 0) {
        const pageName = isEtcLine.value ? "EtcComplete" : "Complete";
        router.replace({ name: pageName });
        return;
      }

      let callBackFunc = undefined;
      // 예약 만료로 인해 결제 실패된 경우 에러 팝업 표출 후 메인화면을 이동 처리
      if (result.resultCode === 408100001) {
        callBackFunc = () => router.push({ name: "Main" });
      }

      // 화면에 머무는 에러의 경우 재시도가 가능하도록 isPaying 해제
      isPaying.value = false;
      proxy.$root.$openErrorPopup({
        errorCode: result.resultCode,
        errorTime: dayjs(result.resultTs).format("YYYY-MM-DD HH:mm:ss"),
        errorMessage: result.resultMessage,
        callBackFunc,
      });
    };

    // 무료 예약(book-free) - 임시 예약 없이 즉시 확정
    const bookFree = async () => {
      // 현재 예약 가능한 구간이 아니면 안내 후 종료
      const bookIntervalCode = store.getters["common/currentBookIntervalCode"];
      if (!bookIntervalCode) {
        isPaying.value = false;
        proxy.$root.$openErrorPopup({
          errorTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          errorMessage:
            "현재는 예약 가능한 기간이 아닙니다. 예약 가능한 기간을 확인해주세요",
        });
        return;
      }

      const params = {
        protocol: window.location.protocol.replace(/:/g, ""),
        iosYn: isIOS(),
        autoAssignDupSeatYn: false,
        bookIntervalCode,
        lines: lines.value,
      };

      const result = await store.dispatch("book/BOOK_FREE", params);

      // 네트워크 오류 등으로 응답이 없는 경우(액션이 undefined 반환) 안내 후 재시도 가능하도록 처리
      if (!result) {
        isPaying.value = false;
        proxy.$root.$openErrorPopup({
          errorTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          errorMessage:
            "예약 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
        });
        return;
      }

      if (result.resultCode === 0) {
        const pageName = isEtcLine.value ? "EtcComplete" : "Complete";
        router.replace({ name: pageName });
        return;
      }

      // book-free는 임시 예약이 아니므로 실패 시 생성되는 예약이 없다. 재시도 가능하도록 isPaying 해제 후 안내.
      isPaying.value = false;
      proxy.$root.$openErrorPopup({
        errorCode: result.resultCode,
        errorTime: dayjs(result.resultTs).format("YYYY-MM-DD HH:mm:ss"),
        errorMessage: result.resultMessage,
      });
    };

    // 결제방법 조회
    const getPG = async () => {
      const result = await store.dispatch("book/FETCH_PG");
      if (result.resultCode !== 0) {
        return;
      }
      payType.value = result.data?.[0]?.code;
    };

    const openPopupForPay = () => {
      const popupInfo = {
        title: `${payTitle.value}하시겠습니까?`,
        content: "",
        leftBtnName: "아니오",
        rightBtnName: `네, ${payTitle.value}할게요`,
        onLeftBtn: () => {
          isPaying.value = false;
          proxy.$root.$closePopup();
        },
        onRightBtn: () => {
          isFreeBooking.value ? freeBook() : payment();
          proxy.$root.$closePopup();
        },
      };
      proxy.$root.$openPopup(popupInfo);
    };

    const onceClick = (fn) => {
      return () => {
        if (!isPaying.value) {
          isPaying.value = true;
          fn();
        }
      };
    };

    const payment = () => {
      payType.value === "PGC-KCP" ? kcpPayment() : kakaoPayment();
    };

    window.openKCP = () => {
      isPaying.value = false;
    };

    const accessToken = computed(() => store.state.member.accessToken);

    // 지정석 여부
    const hasAssignedSeatLine = computed(
      () => !!store.state.line.hasAssignedSeatLine
    );

    const joinFirst = computed(() => store.getters["common/joinFirst"]);

    // kcp 결제
    const kcpPayment = () => {
      // isPaying.value = true;
      const forwardLines = computed(() => store.state.book.forwardLines);
      const backwardLines = computed(() => store.state.book.backwardLines);
      const serviceUid = store.getters["common/serviceUid"];
      const serviceCode = store.getters["common/serviceCode"];
      window.sessionStorage.setItem(
        "payInfo",
        JSON.stringify({
          forwardLines: forwardLines.value,
          backwardLines: backwardLines.value,
          userInfo: userInfo.value,
          serviceUid,
          serviceCode: serviceCode.toLowerCase(),
          accessToken: accessToken.value,
          bookUid: bookUid.value,
          hasAssignedSeatLine: hasAssignedSeatLine.value,
        })
      );

      const protocol = useIsMobile() ? "MOBILE" : "PC";
      const params = { protocol };

      // 결제 실패 후 돌아온 경우에는 bookUid 말고 lines로 새로운 결제를 요청해야 한다.
      if (isCancel.value || !joinFirst.value) {
        params.lines = lines.value;
      } else {
        params.bookUid = bookUid.value;
      }

      kcpSubmit(params);
    };

    const kcpSubmit = (params) => {
      const baseUrl = `${process.env.VUE_APP_API_URL}/aibos/client/api`;
      // const baseUrl = `http://localhost:8080/aibos/client/api`;
      const serviceUid = computed(() => store.state.common.serviceInfo.uid);
      const contextPath = `${baseUrl}/v${process.env.VUE_APP_API_VERSION}/service/${serviceUid.value}/book-kcp`;
      const frontPath = window.location.href.split("/");
      params.cancelUrl = frontPath[frontPath.length - 1];
      document.kcpForm.target = useIsMobile() ? "_self" : "kcpFrame";
      document.kcpForm.action = contextPath;
      document.kcpForm.jsonBody.value = JSON.stringify(params);
      document.kcpForm.submit();
    };

    window.paymentResult = (result) => {
      isPaying.value = false;
      if (result.resultCode !== "0") {
        proxy.$root.$openErrorPopup({
          errorCode: result.resultCode,
          errorTime: dayjs(result.resultTs).format("YYYY-MM-DD HH:mm:ss"),
          errorMessage: result.resultMessage,
        });
        return;
      }
      const { bookUid } = result;
      router.push({ name: "Complete", query: { bookUid } });
    };

    const isIOS = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      if (
        userAgent.indexOf("iphone") !== -1 ||
        userAgent.indexOf("ipad") !== -1 ||
        userAgent.indexOf("ipod") !== -1
      ) {
        return true;
      } else {
        return false;
      }
    };

    const kakaoPayment = async () => {
      // isPaying.value = true;
      const protocol = window.location.protocol.replace(/:/g, "");
      const params = {
        protocol,
        iosYn: isIOS(),
        lines: lines.value,
      };
      const result = await store.dispatch("book/KAKAO_PAY", params);

      if (result?.status !== 200) {
        return;
      }

      const {
        nextRedirectMobileUrl: mobileUrl,
        nextRedirectPcUrl: pcUrl,
        bookUid,
      } = result.data.data;
      const forwardLines = computed(() => store.state.book.forwardLines);
      const backwardLines = computed(() => store.state.book.backwardLines);
      const serviceUid = store.getters["common/serviceUid"];
      const serviceCode = store.getters["common/serviceCode"];
      window.sessionStorage.setItem(
        "payInfo",
        JSON.stringify({
          forwardLines: forwardLines.value,
          backwardLines: backwardLines.value,
          userInfo: userInfo.value,
          bookUid,
          serviceUid,
          serviceCode: serviceCode.toLowerCase(),
          accessToken: accessToken.value,
        })
      );

      const url = useIsMobile() ? mobileUrl : pcUrl;
      try {
        window.location.replace(url);
      } catch (e) {
        window.location = url;
      }
    };

    return {
      infoList,
      userInfo,
      accessToken,
      selectedLines,
      isPaying,
      payType,
      totalFareAmount,
      isCancel,
      pgList,
      isFreeBooking,
      serviceInfo,
      isEtcLine,
      payTitle,
      reservInfoTitle,
      openMapInfo,
      kcpPayment,
      payment,
      onceClick,
      openPopupForPay,
      freeBook,
    };
  },
};
</script>

<style lang="scss" scoped>
.container_wrap {
  padding: 24px 0 120px;
}
.button_area {
  position: fixed;
  width: 100%;
  padding: 20px 0;
  bottom: 0;
  box-sizing: border-box;
  margin: 0;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) -9%,
    #fff 22%
  );
}
@media screen and (min-width: 800px) {
  .button_area {
    max-width: calc(470px / 1.25 - 32px);
  }
}
@media screen and (max-width: 799px) {
  .button_area {
    max-width: calc(470px - 32px);
  }
}
@media screen and (max-width: 470px) {
  .button_area {
    max-width: calc(100% - 32px);
  }
}
</style>
